@if (opened()) {
  <div class="preview-overlay" tabindex="0" (click)="close()" (keydown.escape)="close()">
    <div
      class="preview-container"
      role="dialog"
      aria-modal="true"
      tabindex="0"
      (click)="$event.stopPropagation()"
      (keydown)="onContainerKeydown($event)">
      <button class="close-btn" type="button" aria-label="Close preview" (click)="close()">
        <sxw-svg-icon name="cross" width="16" height="16" strokeColor="rgba(255, 255, 255, 0.92)"></sxw-svg-icon>
      </button>

      <!-- Toolbar -->
      <div
        class="preview-toolbar"
        role="toolbar"
        tabindex="0"
        (click)="$event.stopPropagation()"
        (keydown.enter)="$event.stopPropagation()"
        (keydown.space)="$event.stopPropagation()">
        <button type="button" class="tool-btn" (click)="zoomOut()" aria-label="Zoom out">
          <sxw-svg-icon name="minus" width="16" height="16" strokeColor="rgba(255, 255, 255, 0.92)"></sxw-svg-icon>
        </button>
        <div class="zoom-label" aria-live="polite">{{ zoomPercent() }}%</div>
        <button type="button" class="tool-btn" (click)="zoomIn()" aria-label="Zoom in">
          <sxw-svg-icon name="plus" width="16" height="16" strokeColor="rgba(255, 255, 255, 0.92)"></sxw-svg-icon>
        </button>

        <div class="tool-sep" aria-hidden="true"></div>

        <button type="button" class="tool-btn" (click)="fitToScreen()">
          {{ "IMAGE_PREVIEW.TOOLBAR.FIT" | translate }}
        </button>
        <button type="button" class="tool-btn" (click)="resetView()">
          {{ "IMAGE_PREVIEW.TOOLBAR.RESET" | translate }}
        </button>

        <div class="tool-sep" aria-hidden="true"></div>

        <button type="button" class="tool-btn" (click)="downloadFile()" aria-label="Download">
          <sxw-svg-icon name="download" width="16" height="16" strokeColor="rgba(255, 255, 255, 0.92)"></sxw-svg-icon>
        </button>
      </div>

      <!-- Stage -->
      <div
        class="preview-stage"
        #stage
        (wheel)="onWheel($event)"
        (mousedown)="onPanStart($event)"
        (mousemove)="onPanMove($event)"
        (mouseup)="onPanEnd()"
        (mouseleave)="onPanEnd()">
        @if (isLoading()) {
          <div class="loading-layer">
            <div class="skeleton"></div>
            <div class="spinner"></div>
          </div>
        }

        @if (loadError()) {
          <div class="error-layer">
            <div class="error-card">
              <sxw-svg-icon name="cross" width="24" height="24" strokeColor="var(--p-red-400)"></sxw-svg-icon>
              <p class="error-card__message">{{ "IMAGE_PREVIEW.IMAGE.ERROR.MESSAGE" | translate }}</p>
              <button type="button" class="tool-btn" (click)="retryLoad()">
                {{ "IMAGE_PREVIEW.IMAGE.ERROR.RETRY" | translate }}
              </button>
            </div>
          </div>
        }

        @if (src()) {
          <img
            #imgEl
            class="preview-image"
            [class.is-loading]="isLoading()"
            [style.transform]="transform()"
            [src]="src()!"
            [alt]="imageAlt() | translate"
            (load)="onImageLoad()"
            (error)="onImageError()"
            draggable="false" />
        }
      </div>
    </div>
  </div>
}
